import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { browserHistory } from 'react-router';

import { listDepartmentByRegion, listSpecialties, listEquipments } from '../../datas/DatasActions'
import { updateProvider, uploadDocument, deleteDocument, retrieveProvider, validDocument } from '../ProviderActions'
import FormStepFour from '../components/FormStepFour'

import { parseValueProvider } from '../../utils/parse'

import { addNotifSuccess, addNotifError } from '../../notification/NotificationActions'


const mapStateToProps = (state) => {
    return {
        user : state.user,
        provider : state.provider.provider,
        initialValues: state.provider.provider.provider
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        uploadDocument:(id, file, name) => {
            return dispatch(uploadDocument(id, file, name))
        },
        deleteDocument: (id, name) => {
            return dispatch(deleteDocument(id, name))
        },
        validDocument: (id, valid) => {
            return dispatch(validDocument(id, valid)).then(function(data){
                dispatch(updateProvider(id))
            })
        }
    }
}



const config = {
    form: 'FormStepFourForm',
    onSubmit: (values, dispatch, props) => {
        window.scrollTo(0, 0);

        const fields = [
            "free_text"
        ];
        var datas = parseValueProvider(fields, values);

        return dispatch(updateProvider(props.provider.provider.id, datas))
            .then((response) => {
                if (props.create) {
                    if (props.newLead)
                        browserHistory.push('/manager/prestataire/' + props.provider.provider.id)
                    else
                        browserHistory.push('/prestataire/confirmation')
                } else {
                    dispatch(addNotifSuccess("Vos informations sont enregistrées", "Confirmation"))
                }
            })
            .catch((error) => {
                dispatch(addNotifError("Veuillez recommencer.", "Erreur"))
            })
    },
    enableReinitialize : true
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(config)(FormStepFour))



// WEBPACK FOOTER //
// ./src/provider/containers/FormStepFourContainer.js